import { apiGet } from './client';
import type { OptionBlackScholes } from '../types/OptionBlackScholes';

// Read-only, tenant-scoped (X-Tenant-Id applied by the client). One row per
// option in the Central ASSETS catalog, valued with this tenant's as-of params.
export function getOptionsBlackScholes(): Promise<OptionBlackScholes[]> {
  return apiGet<OptionBlackScholes[]>('/api/options-black-scholes');
}
